import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Button, message, Spin } from "antd";
import VideoJS from "../videojs";
import "./video.css";
import FourOFour from "../404";
import { getVideoUrl, fetchWechatShareSignature } from "../../api";
import { sign } from "../../utils/sign";
import { fileDownload, isWeChat, urlExists } from "../../utils";

const wx = window.wx;

const Video = () => {
  let { id } = useParams();

  const [url, setUrl] = useState("");
  const [poster, setPoster] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    getVideoUrl(id)
      .then((response) => response.json())
      .then((data) => {
        if (data.result) {
          setUrl(data.result.url);
          setPoster(data.result.poster);

          if (!urlExists(data.result.url)) {
            message.error("抱歉，视频处理中，请稍后(1~3分钟)刷新页面重试！");
          }

          setWechatShare(
            data.result.url,
            data.result.thumb,
            "精彩时刻下载",
            "点击观看/下载您的精彩时刻"
          );
        } else {
          setError(true);
          message.error("抱歉，您访问的资源不存在！");
        }
      })
      .catch((error) => {
        console.error("getVideoUrl error:", error);
        setError(true);
        message.error("抱歉，服务异常，请稍后重试！");
      });
  }, [id]);

  function setWechatShare(url, img, title, desc) {
    fetchWechatShareSignature()
      .then((response) => response.json())
      .then((data) => {
        if (data?.code === 200) {
          const ticket = data.ticket;
          const url = document.location.href;
          const signature = sign(ticket, url);
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: "wxa0a951eaae585963", // 必填，公众号的唯一标识
            timestamp: signature.timestamp, // 必填，生成签名的时间戳
            nonceStr: signature.nonceStr, // 必填，生成签名的随机串
            signature: signature.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
          });
          wx.ready(() => {
            // 需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
              title: title, // 分享标题
              desc: desc, // 分享描述
              link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: img, // 分享图标
              success() {
                // 设置成功
              },
            });
          });
          wx.ready(() => {
            // 需在用户可能点击分享按钮前就先调用
            wx.updateTimelineShareData({
              title: title, // 分享标题
              link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: img, // 分享图标
              success() {
                // 设置成功
              },
            });
          });
        } else {
          console.log("fetchWechatShareSignature error!", data?.msg);
        }
      })
      .catch((error) => {
        console.error("fetchWechatShareSignature error!", error);
      });
  }

  const playerRef = useRef(null);

  const videoJsOptions = {
    autoplay: true,
    controls: true,
    playsinline: true,
    responsive: true,
    fluid: true,
    poster: poster,
    sources: [
      {
        src: url,
        type: "video/mp4",
      },
    ],
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    player.on("waiting", () => {
      console.log("player is waiting");
    });

    player.on("dispose", () => {
      console.log("player will dispose");
    });
  };

  const [downloading, setDownloading] = useState(false);

  const handleVideoSave = (url) => {
    if (isWeChat) {
      message.info('点击右上角“...”，选择在浏览器中打开，进行视频保存！');
    }else{
      setDownloading(true);
      message.info('视频下载中...');
      fileDownload(url, videoSaved);
    }
  };

  const videoSaved = () => {
    setDownloading(false);
    message.info('视频已下载！');
  }

  return (
    <>
      {url ? (
        <div className="video_container">
          <div className="up_video">
            <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
          </div>
          <div className="down_btn">
            <Button type="primary" loading={downloading} onClick={() => handleVideoSave(url)}>
              {downloading ? '视频下载中...' : '保存视频'}
            </Button>
          </div>
        </div>
      ) : (
        <div className="spin_container">
          {error ? <FourOFour /> : <Spin size="large" />}
        </div>
      )}
    </>
  );
};

export default Video;
